import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { ApiService } from '../api.service';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';


@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.css']
})
export class ContactusComponent implements OnInit {
  loading:any
ShowCard:any;
  submitForm!: FormGroup;
  receivedCaptcha:any;
constructor(private service:ApiService,private titleService: Title, private metaService: Meta,
  private renderer: Renderer2, @Inject(DOCUMENT) private document: Document, private router:Router
){}
ngOnInit(): void {

  //  this.titleService.setTitle('FA Check | Contact us');
  //   this.metaService.updateTag({
  //     name: 'description',
  //     content: 'Reach out to FA Check for trusted compliance and verification solutions. We’re here to help you streamline your processes.'
  //   });
 this.setMetaTags();
    this.setCanonicalUrl();
  this.submitForm = new FormGroup({
    name: new FormControl('',Validators.required),
    email: new FormControl('',Validators.required),
    mobileNumber: new FormControl('',Validators.required),
    title: new FormControl('Product Enquiry'),
    
    captcha: new FormControl('',Validators.required),
    comment: new FormControl('',Validators.required),
    howYouKnow: new FormControl('',Validators.required)


  })

}

getCaptcha(){
  let model ={
    mobileNumber:this.mobileNumber?.value,
    email:this.email?.value
  }

  let encrypt = {
    securePayload : this.service.encrypt(JSON.stringify(model))
  }
  this.service.getCaptcha(encrypt).then((res:any)=>{
    if (res.flag == 1) {
      this.receivedCaptcha =  JSON.parse(this.service.decryptData(res.data));
      this.captcha?.reset()
    } else {
      
    }
  }).catch((err)=>{
    Swal.fire({
      icon: 'warning',
      title: 'Something went wrong '+' '+ err.status,
      showConfirmButton: true,
      customClass:{
        popup:'popupClass',
        title:'titleClass',
        icon:'iconClass',
        confirmButton:'buttonClass'

      }
     
    });
  })
}


get name(){
  return this.submitForm.get('name')
}
get email(){
  return this.submitForm.get('email')
}
get mobileNumber(){
  return this.submitForm.get('mobileNumber')
}
get captcha(){
  return this.submitForm.get('captcha')
}
get comment(){
  return this.submitForm.get('comment')
}
get howYouKnow(){
  return this.submitForm.get('howYouKnow')
}

submit(){
  if (this.submitForm.valid) {
    if (this.captcha?.value == this.receivedCaptcha) {
      this.loading = true;
      let encrypt = {
        securePayload : this.service.encrypt(JSON.stringify(this.submitForm.value)) 
      }
      this.service.contactUsForm(encrypt).then((res:any)=>{
        if (res.flag ==1) {
          Swal.fire({
            icon: 'success',
            title: 'Request Submitted Successfully! Thank you for reaching us, Our executives will contact you within 48hrs ',
            showConfirmButton: true,
            customClass:{
              popup:'popupClass',
              title:'titleClass',
              icon:'iconClass',
        confirmButton:'buttonClass'
            }
            // timer: 1500
          });
      this.loading = false;
this.submitForm.reset()
        } else {
          Swal.fire({
            icon: 'warning',
            title: res.message,
            showConfirmButton: true,
            customClass:{
              popup:'popupClass',
              title:'titleClass',
              icon:'iconClass',
        confirmButton:'buttonClass'
            }
            // timer: 1500
          });
      this.loading = false;

        }
      }).catch((err)=>{
        Swal.fire({
          icon: 'warning',
          title: 'Something went wrong '+' '+ err.status,
          showConfirmButton: true,
          customClass:{
            popup:'popupClass',
            title:'titleClass',
                icon:'iconClass',
        confirmButton:'buttonClass'
          }
         
        });
      this.loading = false;

      })
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Captcha Invalid',
        showConfirmButton: true,
        customClass:{
          popup:'popupClass',
          title:'titleClass',
              icon:'iconClass',
        confirmButton:'buttonClass'
        }
       
      });
      
    }
  } else {
    Swal.fire({
      icon: 'warning',
      title: 'Kindly fill all required fields',
      showConfirmButton: true,
      
      customClass:{
        popup:'popupClass',
        title:'titleClass',
            icon:'iconClass',
        confirmButton:'buttonClass'
      }
      // timer: 1500
    });
    this.submitForm.markAllAsTouched();
  }
}


 private setMetaTags(): void {
        // Set page title (works for both server and client)
        this.titleService.setTitle('FA Check | Contact us');
       
        // Update or add meta tags
        this.metaService.updateTag({ name: 'description', content: 'Reach out to FA Check for trusted compliance and verification solutions. We’re here to help you streamline your processes.' });
        // this.metaService.updateTag({ name: 'author', content: 'Your Name' });
       
        // For keywords, use updateTag with proper attribute
//         this.metaService.updateTag({ name: 'keywords', content: 'Association Management Solution, Association Management Software, Best Association Management Solution'
//  });
       
        // Open Graph tags
        this.metaService.updateTag({ property: 'og:title', content: 'FA Check | Contact us' });
        this.metaService.updateTag({ property: 'og:description', content: 'Reach out to FA Check for trusted compliance and verification solutions. We’re here to help you streamline your processes.' });
        this.metaService.updateTag({ property: 'og:url', content: `https://facheck.in${this.router.url}` });
        this.metaService.updateTag({ property: 'og:type', content: 'website' });
       
        // Twitter tags
        this.metaService.updateTag({ name: 'twitter:title', content: 'FA Check | Contact us' });
        this.metaService.updateTag({ name: 'twitter:description', content: 'Reach out to FA Check for trusted compliance and verification solutions. We’re here to help you streamline your processes.' });
        this.metaService.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
       
        // You can also add tags if they don't exist
        // this.addTagIfNotExists('og:image', { property: 'og:image', content: 'https://quickrentpay.com/assets/images/og-image.jpg' });
        // this.addTagIfNotExists('twitter:image', { name: 'twitter:image', content: 'https://quickrentpay.com/assets/images/twitter-image.jpg' });
    }
 
 setCanonicalUrl(): void {
    // Remove query parameters for clean canonical URL
    const cleanUrl = this.router.url.split('?')[0];
    const canonicalUrl = `https://facheck.in${cleanUrl}`;
   
    // Use the same DOM manipulation on both server and client
    this.updateCanonicalLink(canonicalUrl);
  }
 
  private updateCanonicalLink(url: string): void {
    // Find existing canonical link
    const existingLink = this.document.querySelector("link[rel='canonical']");
   
    if (existingLink) {
      // Update existing link if href is different
      const currentHref = existingLink.getAttribute('href');
      if (currentHref !== url) {
        this.renderer.setAttribute(existingLink, 'href', url);
      }
    } else {
      // Create new canonical link if it doesn't exist
      const link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'canonical');
      this.renderer.setAttribute(link, 'href', url);
      this.renderer.appendChild(this.document.head, link);
    }
  }
}
